import(/* webpackMode: "eager", webpackExports: ["FrontPage"] */ "/vercel/path0/web/components/FrontPage/FrontPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ValApp"] */ "/vercel/path0/web/node_modules/@valbuild/next/dist/ValApp-3a70afe1.esm.js");
;
import(/* webpackMode: "eager", webpackExports: ["ValModulesClient","useRegisterValModules"] */ "/vercel/path0/web/node_modules/@valbuild/next/dist/ValModulesClient-0dd601a1.esm.js");
;
import(/* webpackMode: "eager", webpackExports: ["ValNextProvider"] */ "/vercel/path0/web/node_modules/@valbuild/next/dist/ValNextProvider-3d2cd7e4.esm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/image-component.js");
